// ── Confirmed-sibling suppression (single source of truth) ──────────────────
//
// When a request is locked_in, ONLY the clinic-confirmed time is a real
// appointment — the unchosen sibling proposals must be ABSENT from every
// visual surface (calendar grid, week pills), not greyed. They remain in
// the raw payload and the request card's detail list.
// Pending / suggested_alternative requests render all their times.
//
// Both the Network week-pill surface (NetworkScheduling.jsx) and the
// read-only calendar grid (NetworkCalendarGrid.jsx) MUST import this —
// no local filtering copies, so the surfaces can never disagree.
export function visibleProposedTimes(request) {
  const times = request?.proposed_times || [];
  if (request?.status === "locked_in") {
    return times.filter((p) => p.is_confirmed);
  }
  return times;
}
